import { createSelector } from "reselect";

const Notifications = () => (state) => state.notifications;

const selectNotificationsContainer = () =>
  createSelector(Notifications(), (notificationsData) => {
    return notificationsData;
  });

export default selectNotificationsContainer;